export default __webpack_public_path__ + "static/media/blog3.e8477144.jpg";